import React from "react";
import HelmetComponent from "../../../components/shared/Helmet";
import { Link } from "react-router-dom";

function Navigation({isLoggedIn = false}) {
  return (
    <React.Fragment>
      <HelmetComponent
        title=" For You | ausbiz"
        noIndex="true"
      />
      <div className="navigation-title-wrap for-you-page">
        <div className="container">
          <div className="navigation-title-img-block">
            <div className="navigation-title-right">
              <div className="navigation-title navigation-expert-title foryou-title">
                <h1>
                  For You
                </h1>
                {isLoggedIn &&
                  <div className="watchlist-btn show-mobile">
                    <Link to="/follow-management">
                      <span>Manage Watchlist</span>
                    </Link>
                  </div>
                }
              </div>
              <div className="navigation-info">
                <p>
                  <span>Your curated feed of content based on the companies, experts and topics you follow.</span>
                </p>
              </div>
            </div>
          </div>
          {isLoggedIn &&
            <div className="watchlist-btn hide-mobile">
              <Link to="/follow-management">
                <span>Manage Watchlist</span>
              </Link>
            </div>
          }
        </div>
      </div>
    </React.Fragment>
  );
}

export { Navigation };